define('modules/login/service/Auth',[
	"modules/common/lib/webtoolkit.base64"
], function(Base64) {
	var Auth = function($http, Studio, $q, PATH, LoadingHandler) {
		return {
			requestToken: function(username, password) {

				LoadingHandler.start();

				var deferred = $q.defer();

				$http.defaults.headers.common['Authorization'] = 'Basic ' + Base64.encode(username + ':' + password);

				var manageErrors = function(error) {
					deferred.reject({
						status: error.status,
						data: error.data
					});
					LoadingHandler.stop();
				};


				var loginCall = function(id) {
					$http({
						method: 'GET',
						url: 'https://' + PATH.ENTRYPOINT + '/' + id + '/login',
						cache: false
					}).then(
						function(response) {
							deferred.resolve(response.data.token);
							LoadingHandler.stop();
						},
						manageErrors);
				};


				Studio.getId().then(loginCall, manageErrors);


				return deferred.promise;
			}
		};
	};

	return ["$http", "Studio", "$q", "PATH", "LoadingHandler", Auth];
});
